import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, UrlSegment } from '@angular/router';
import { OAuthService, AuthConfig, JwksValidationHandler } from 'angular-oauth2-oidc';
import { DatePipe } from '@angular/common'

import { AuthService } from '../services/auth.service';
import { CommonService } from '../common.service';
import * as  forge from 'node-forge';


import { environment } from '../environment';
import { ExpenseHttpService } from '../services/expense/expense-http.service';
import { ToasterService } from '../+layout/expense/toaster/toaster.service';
import * as moment from 'moment';
import { BehaviorSubject, Subject } from 'rxjs';
// import { GoogleLoginProvider, SocialAuthService } from 'angularx-social-login';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  OrOption: boolean = true;
  Phone: '' ;
  OTPget: any;
  countryCode = '+91';
  Countryflag = "../../assets/img/Flags/in.png"
  EmailId: string = '';
  Password: string = '';
  PasswordError: string = '';
  UserError: string = '';
  text: "ISD Code"
  errorMessage: string;
  showLoader: boolean;
  returnUrl: any;
  forgotPassword: any = {};
  modalMessage: string = '';
  resetPasswordSubmitted = false;
  showPhone: boolean = true;
  disableMobile: boolean = false;
  showPassword: boolean = false;
  remmbermeTab: boolean =false;
  showEmail: boolean = true;
  showOtp: boolean = false;
  showGetOtp: boolean = false;
  LoginWithEmail: boolean = false;
  showisdCode: boolean = false;
  LoginWithNumber: boolean = false;
  errormsg : boolean = true;
  successmsg: boolean = false;
  UserId: any;
  CmpCode: any;
  loginCmpCode: any;
  ISDCode: any [] = this.commonService.getCountrycodes();
  fields: Object = { text: 'code', value: 'code' };
  timerOn: boolean;
  stopForCheck: boolean = false;

  constructor(public date: DatePipe, private router: Router, private route: ActivatedRoute, private authService: AuthService, public toaster: ToasterService,
    private commonService: CommonService,
    // private loginAuth: SocialAuthService,
    private Http: ExpenseHttpService) {
    this.CmpCode = this.authService.getcompanyCode();
    // let userId = this.authService.getUserId();
    // this.UserId = userId;
  }

  ngOnInit() {

    if (this.authService.getToken()) {
      this.router.navigate(['home']);
    }
    // let userId = this.authService.getUserId();
    // this.UserId = userId;

    this.forgotPassword = { email: '', message: '' };

    this.ISDCode = this.commonService.getCountrycodes();
    // let base = document.getElementsByTagName("base")
    // let baseVal = base[0].baseURI
    // debugger
    // if(baseVal != environment.DynamicBaseUrl+ "Customer"){
    //   window.location.reload();
    // }
  }

  onPasswordEnter(val){

    this.Password = val

  }

  userType: any;
  timeAddMinutes(time, min) {
    var t = time.split(":"),      // convert to array [hh, mm, ss]
        h = Number(t[0]),         // get hours
        m = Number(t[1]);         // get minutes
    m+= min % 60;                 // increment minutes
    h+= Math.floor(min/60);       // increment hours
    if (m >= 60) { h++; m-=60 }   // if resulting minues > 60 then increment hours and balance as minutes

    return (h+"").padStart(2,"0")  +":"  //create string padded with zeros for HH and MM
           +(m+"").padStart(2,"0") +":"
           +t[2];                        // original seconds unchanged
    }
    ResetAttempts(){
      this.attempts = 0
    }
    multiUserInfo
   obj
   obj2
  SignIn() {
    this.showLoader = true;
    this.errorMessage = "";
    if(this.attempts == 3){
      this.showLoader = false;
      this.timeCheck = true;
      this.EmailId
      this.errorMessage = "Sign In Locked, Please try After 30 Minutes";
      this.authService.LoginWarn(this.EmailId).subscribe(res => {
        if(res == "success"){

        }
      });
      return
    }

    try {
      let encryptedPassword  = forge.util.binary.hex.encode(forge.pkcs5.pbkdf2(this.Password, 'a salt', 1000, 256/8));
      this.obj = this.authService.loginUser(this.EmailId, encryptedPassword, null).subscribe(response => {

        //  this.obj2 = this.authService.getUserComponies(this.EmailId, response.access_token).subscribe( res => {

        //   if(res.data.table.length > 1){
        //   this.commonService.OpenModalHandler("MultiUser");
        //   this.stopForCheck = true;
        //   this.showLoader = false;
        //   this.multiUserInfo = res.data.table;
        //   this.obj.unsubscribe();
        // this.obj2.unsubscribe();
        //   return
        // }else{
          this.stopForCheck = false
          if(response.islogged == "1"){

            let getTime =  response.lastlogindate
            let datearray = getTime.split("");
            let i =datearray.length - 2;
            datearray.splice(i, 0, " ")
            let newdate = datearray.join("");
            let date = new Date(newdate);
            date.setMinutes( date.getMinutes() + 30 );
            let newTime = date.toTimeString().slice(0,5)
            let formatTime = newTime.replace(":", ".");
            let printTime = moment(formatTime, ["HH.mm"]).format("hh:mm A");
            this.errorMessage = "Sign In Locked, Please try After "+printTime;
            this.showLoader = false;
            return
          }
          this.toaster.show("success", "You Have Successfully Logged In");
          this.UserId = response.userId;
          this.authService.setToken(response.access_token, response[".expires"]);
          this.authService.setUsername(response.userName);
          this.authService.setUseremail(response.userEmail);
          this.authService.setUserFullName(response.userFullName);
          this.authService.setUserId(response.userId);
          this.authService.setUserType(response.userType);
          this.authService.setUName(response.uName);
          this.userType = response.userType;
          this.GetLoginusers();

        // }
        // })

      }, error => {
        this.errorMessage = error.error.error_description;
        this.attempts += 1;
        this.showLoader = false;
      });
    } catch (error) {
      console.log(error);

    }


  }

  UsuerChoosedCompony(val){


  this.authService.logout();
  let encryptedPassword  = forge.util.binary.hex.encode(forge.pkcs5.pbkdf2(this.Password, 'a salt', 1000, 256/8));
  this.authService.loginUser(this.EmailId, encryptedPassword, val+"").subscribe(response => {
  // this.authService.getUserComponies(this.EmailId).subscribe( res => {

      this.stopForCheck = false
      if(response.islogged == "1"){

        let getTime =  response.lastlogindate
        let datearray = getTime.split("");
        let i =datearray.length - 2;
        datearray.splice(i, 0, " ");
        let newdate = datearray.join("");
        let date = new Date(newdate);
        date.setMinutes( date.getMinutes() + 30 );
        let newTime = date.toTimeString().slice(0,5)
        let formatTime = newTime.replace(":", ".");
        let printTime = moment(formatTime, ["HH.mm"]).format("hh:mm A");
        this.errorMessage = "Sign In Locked, Please try After "+printTime;
        this.showLoader = false;
        return
      }
      this.toaster.show("success", "You Have Successfully Logged In");
      this.UserId = response.userId;
      this.authService.setToken(response.access_token, response[".expires"]);
      this.authService.setUsername(response.userName);
      this.authService.setUseremail(response.userEmail);
      this.authService.setUserFullName(response.userFullName);
      this.authService.setUserId(response.userId);
      this.authService.setUserType(response.userType);
      this.authService.setUName(response.uName);
      this.userType = response.userType;
      this.GetLoginusers();

    // })

  }, error => {
    this.errorMessage = error.error.error_description;
    this.attempts += 1;
    this.showLoader = false;
  });

  }
  userback(){
    this.authService.logout();
  }
  CurrentOTP;
  CurrentStatus;
  userName;
  PasswordNew;
  MoreLogins = false;
  checkInterval:any
  getOTP(){

    this.showOtp = true;
    this.showGetOtp = false;
    if(this.countryCode == "" || this.countryCode == undefined){
      this.errormsg  = true;
      this.successmsg = false;
      this.errorMessage = "Please a Select Country Code";

      return
    }
    if(this.Phone == "" || this.Phone == undefined){
      this.errormsg  = true;
      this.successmsg = false;
      this.errorMessage = "Please Enter a Phone Number";
      this.showGetOtp = true;
      this.showOtp = false;
      return
    }

    else{
      let Number = ""+this.Phone

      let OTP = this.authService.GetOTP(this.Phone, this.countryCode ).subscribe((res) => {
        if(res.success){

        this.CurrentOTP = res.message;
        this.CurrentStatus = res.success;
        this.userName = res.data.table[0].username;
        this.PasswordNew = res.data.table[0].passwordHash;
        this.errorMessage = "OTP sent to "+ Number;
        this.errormsg  = false;
        this.successmsg = true;
        this.checkInterval=false
        this.timer(2)

      // setInterval(() => {
      //   this.successmsg = false;
      //   this.errormsg  = false;
      //   this.checkInterval=true
      // }, 30000);

        }else{
          this.errormsg  = true;
          this.successmsg = false;
          this.errorMessage = "Not a Registered Phone Number"
          this.showGetOtp = true;
          this.showOtp = false;
        }


      }, error => {
        this.errorMessage = error.error.error_description;
        this.showLoader = false;
      });
    }


  }
 myFunction(){
    console.log('myFunction Called')
}

display: any;
killTimer = false
timer(minute) {
  // let minute = 1;
  let seconds: number = minute * 60;
  let textSec: any = "0";
  let statSec: number = 60;

  const prefix = minute < 10 ? "0" : "";

  const timer = setInterval(() => {
    seconds--;
    if (statSec != 0) statSec--;
    else statSec = 59;

    if (statSec < 10) {
      textSec = "0" + statSec;
    } else textSec = statSec;

    this.display = "Get OTP again in " + `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

    if (seconds == 0 || this.killTimer) {
      console.log("finished");
      clearInterval(timer);
    }
  }, 1000);
}

RegetOTP(){

  this.showOtp = true;
  this.showGetOtp = false;
  if(this.countryCode == "" || this.countryCode == undefined){
    this.errormsg  = true;
    this.successmsg = false;
    this.errorMessage = "Please a Select Country Code";

    return
  }
  if(this.Phone == "" || this.Phone == undefined){
    this.errormsg  = true;
    this.successmsg = false;
    this.errorMessage = "Please Enter a Phone Number";
    this.showGetOtp = true;
    this.showOtp = false;
    return
  }

  else{
    let Number = ""+this.Phone

    let OTP = this.authService.GetOTP(this.Phone, this.countryCode ).subscribe((res) => {
      if(res.success){
      this.timer(2)
      this.CurrentOTP = res.message;
      this.CurrentStatus = res.success;
      this.userName = res.data.table[0].username;
      this.PasswordNew = res.data.table[0].passwordHash;
      this.errorMessage = "OTP resend to "+ Number;
      this.errormsg  = false;
      this.successmsg = true;
      this.checkInterval=false
      this.timerOn = true



    // setInterval(() => {
    //   this.successmsg = false;
    //   this.errormsg  = false;
    //   this.checkInterval=true
    // }, 30000);

      }else{
        this.errormsg  = true;
        this.successmsg = false;
        this.errorMessage = "Not a Registered Phone Number"
        this.showGetOtp = true;
        this.showOtp = false;
      }


    }, error => {
      this.errorMessage = error.error.error_description;
      this.showLoader = false;
    });
  }


}



  LoginByOTP(){
  if(this.CurrentOTP == undefined || this.OTPget == undefined ){
    this.errormsg  = true;
    this.successmsg = false;
    this.errorMessage  = "Please Enter Phone Number Or OTP";

  }else{
    if(this.CurrentOTP/56 == this.OTPget){


      this.authService.loginUser(this.userName, this.PasswordNew, null).subscribe(response => {
        this.toaster.show("success", "You Have Successfully Logged In");

        this.UserId = response.userId;
        this.authService.setToken(response.access_token, response[".expires"]);
        this.authService.setUsername(response.userName);
        this.authService.setUseremail(response.userEmail);
        this.authService.setUserFullName(response.userFullName);
        this.authService.setUserId(response.userId);
        this.authService.setUserType(response.userType);
        this.authService.setUName(response.uName);
        this.GetLoginusers();
        this.userType = response.userType;

      }, error => {
        this.errorMessage = error.error.error_description;
        this.showLoader = false;
      });

     }
     else{
      this.errorMessage = "Please Enter Correct OTP";
      this.errormsg = true;
      this.successmsg = false;
     }
  }

  }
  resetForgotPasswordForm() {
    this.forgotPassword = { email: '', message: '' };
  }
  showForgotPasswordModal() {
    this.resetForgotPasswordForm();
    this.openModal('ForgotPasswordModal');
  }
  openModal(modalId: string) {
    this.commonService.OpenModalHandler(modalId);
  }
  closeForgotPasswordModal() {
    this.commonService.CloseModalHandler('ForgotPasswordModal');
    this.resetPasswordSubmitted = false;
  }
  getForgotPasswordToken() {
    this.showLoader = true;
    this.resetPasswordSubmitted = true;
    this.authService.getForgotPasswordToken(this.forgotPassword.email).subscribe(response => {
      this.closeForgotPasswordModal();
      this.showLoader = false;
      this.modalMessage = response;
      this.resetForgotPasswordForm();
      this.openModal('MessageModal');
    }, error => {
      this.forgotPassword.message = error.error.message;
      this.showLoader = false;
    });
  }

  GetLoginusers() {

    this.Http.GetLoginusers(this.UserId, this.CmpCode).then((res: any) => {
      if (res.success === true) {

        let roleId = res.data.table[0].roleId;
        let themeId = res.data.table[0].themeId;
        let currency = res.data.table[0].currency;
        let logo = res.data.table[0].logo;
        let noofCustomer = res.data.table[0].noofCustomer;
        let noofUsers = res.data.table[0].noofUsers;
        let userImage = res.data.table[0].userImage;
        let companyCode = res.data.table[0].companyCode;
        this.loginCmpCode = res.data.table[0].companyCode;
        let projectcoderequired = res.data.table[0].projectcoderequired;
        let projectprefix = res.data.table[0].projectprefix;
        let projectstart = res.data.table[0].projectstart;
        let customerrequired = res.data.table[0].customerrequired;
        let customerprefix = res.data.table[0].customerprefix;
        let customerstart = res.data.table[0].customerstart;
        let employeerequired = res.data.table[0].employeerequired;
        let employeeprefix = res.data.table[0].employeeprefix;
        let employeestart = res.data.table[0].employeestart;
        let addressrequired = res.data.table[0].addressrequired;
        let addressprefix = res.data.table[0].addressprefix;
        let addressstart = res.data.table[0].addressstart;
        let decimalFormat = res.data.table[0].decimalFormat;
        let dateFormat = res.data.table[0].dateFormat;
        let endTime = res.data.table[0].endTime;
        let startTime = res.data.table[0].startTime;
        let locationId=res.data.table[0].locationId
        let subRoleId = res.data.table[0].subroleid;
        let finStartDate = res.data.table[0].financialYearStartDate;
        let finEndDate = res.data.table[0].financialYearEndDate;
        // let cmpName = res.data.table[0].companyName
        // cmpName = cmpName.split(' ').join('_')
        // cmpName = cmpName.split('.').join('_')

        this.authService.settimeformat(res.data.table[0].timeFormat);
        // this.authService.setcmpName(cmpName);
        this.authService.setRoleId(roleId);
        this.authService.setSubRoleId(subRoleId);
        this.authService.setThemeId(themeId);
        this.authService.setCurrency(currency);
        this.authService.setFinancialYearStart(finStartDate);
        this.authService.setFinancialYearEnd(finEndDate);
        this.authService.setLogo(logo);
        this.authService.setNoOfCustomer(noofCustomer);
        this.authService.setNoOfUsers(noofUsers);
        this.authService.setUserImage(userImage);
        this.authService.setcompanyCode(companyCode);
        this.authService.setprojectcoderequired(projectcoderequired);
        this.authService.setprojectprefix(projectprefix);
        this.authService.setprojectstart(projectstart);
        this.authService.setcustomerrequired(customerrequired);
        this.authService.setcustomerprefix(customerprefix);
        this.authService.setcustomerstart(customerstart);
        this.authService.setemployeerequired(employeerequired);
        this.authService.setemployeeprefix(employeeprefix);
        this.authService.setemployeestart(employeestart);
        this.authService.setaddressrequired(addressrequired);
        this.authService.setaddressprefix(addressprefix);
        this.authService.setaddressstart(addressstart);
        this.authService.setdecimalFormat(decimalFormat);
        this.authService.setdateFormat(dateFormat);
        this.authService.setStartTime(startTime);
        this.authService.setEndTime(endTime);
        this.authService.setLocationId(locationId)
        this.getstatus();
        this.Getformassignment();
        // let baseDOM = document.getElementsByTagName("base")
        // let strURL = baseDOM[0].href.split("Customer")
        // window.location.href = strURL[0]+ cmpName+ "#" + "/home"
        // if(roleId == 1){
        //   setTimeout(() => {

        //     if(strURL.length == 0){
        //       window.location.href = strURL[0] + "#" + "/home"
        //     }else{
        //       window.location.href = strURL[0]+ cmpName+ "#" + "/home"
        //     }

        //   }, 1000);
        // }else{
        //   setTimeout(() => {

        //     if(strURL.length == 0){
        //       window.location.href = strURL[0] + "#" + "/home"
        //     }else{
        //       window.location.href = strURL[0]+ cmpName+ "#" + "/home"
        //     }

        //   }, 500);
        // }




      }
    })
  }
  lastcheckedin: any;
  currenttime: any
  async getstatus() {
    let date = new Date();
    let shortdate = this.date.transform(date, 'yyyy-MM-dd HH:mm:ss');

    const params =
    {
      userid: this.authService.getUserId(),
      cmpcode: this.authService.getcompanyCode(),
      date: shortdate

    }

    await this.authService.getcheckinstatus(params).subscribe(response => {






      if (response.success == true) {
if(response.data.table[0].totalattempt==undefined)
{
  this.authService.setNoOfAttepmts('0');
}else{
      this.authService.setNoOfAttepmts(response.data.table[0].totalattempt);
}

        //response.data=
        if (response.data.table[0].checkinstatus == '1') {
          let lastdate = new Date(response.data.table[0].dateon);
          this.lastcheckedin = lastdate;
          this.currenttime = new Date();
          let differencefrommints = this.currenttime - this.lastcheckedin;
          let totalmint = Math.floor(differencefrommints / 60000);

          let mints = response.data.table[0].mintues;
          let totalmintts = totalmint + mints;
          let milisecs = totalmintts * 60000;
          let actualdatobesaved = this.currenttime - milisecs;
          let convertstringtodate = new Date(actualdatobesaved);

          this.authService.setCheckin(response.data.table[0].checkinstatus);
          this.authService.setCheckininTime(convertstringtodate);


        }
        if (response.data.table[0].checkinstatus == '2' || response.data.table[0].checkinstatus == '0' ) {
          this.authService.setCheckin(response.data.table[0].checkinstatus);
          this.authService.setCheckininTime('');
        }

      }

      this.authService.getUserPermission(parseInt(this.UserId), this.UserId, this.CmpCode).subscribe(res => {
        this.authService.setPermission(JSON.stringify(res.data));
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'home';
        this.router.navigateByUrl(this.returnUrl);
        this.router.navigate([this.returnUrl]);
      });
    });
  }
  IsPermissions: any = [];
  checkThis: any = []
  OnLoginWithNumber(){

   this.OnPhoneLogin();
   this.killTimer = false;
   this.disableMobile = false;
   this.MoreLogins = true;
   this.errorMessage = "";
   this.errormsg = false;
   this.successmsg = false;
   this.display = "";
  }
  OnLoginWithEmail(){

   this.OnPasswordLogin();
  //  clearInterval();
  this.killTimer = true;
   this.MoreLogins = true;
   this.successmsg = false;
   this.errormsg = true;
   this.errorMessage = "";
   this.display = "";
  }
  setCountryCode(val){

    let isd = val.value;
    this.countryCode = isd;
    let valfalg = this.ISDCode.filter((x) => x.code == val.value);
    this.Countryflag = valfalg[0].flag
  }
  OnPasswordLogin(){

    this.showPassword = true;
    this.showPhone = false;
    this.OrOption = false;
    this.showOtp = false;
    this.showEmail = true;
    this.LoginWithNumber = true;
    this.LoginWithEmail = false;
    this.MoreLogins = true;
    this.remmbermeTab = true;
    this.showGetOtp = false;
    this.showisdCode = false;
  }
  OnPhoneLogin(){

    this.showEmail = false;
    this.showPassword = false;
    this.showPhone = true;
    this.OrOption = false;
    this.showOtp = false;
    this.disableMobile = false;
    this.showPassword =  false;
    this.LoginWithEmail = true;
    this.LoginWithNumber = false;
    this.MoreLogins = true;
    this.remmbermeTab = false;
    this.showGetOtp = true;
    this.showisdCode = true;

  }
  OnOTPAuth(){
    this.showOtp = true;
    this.showGetOtp = false;
  }
  onGoogleSignIn() {
    // this.loginAuth.signIn(GoogleLoginProvider.PROVIDER_ID);
  }
  timeCheck  = false;
  attempts = 0;

  Getformassignment() {
    this.Http.Getformassignment(this.UserId, this.loginCmpCode).then((res: any) => {
      if (res.success === true) {
        this.IsPermissions = res.data.table;

        localStorage.setItem('IsPermissions', JSON.stringify(this.IsPermissions));
      } else {
        localStorage.setItem('IsPermissions', JSON.stringify(0));
      }
    }, (error) => {
      localStorage.setItem('IsPermissions', JSON.stringify(0));
    })
  }

}

